import { fetchBooksFromNotion } from '../api/notionPublicApi';

export const getBookData = async () => {
    console.log('getBookData called');
    const books = await fetchBooksFromNotion();
    console.log('Books received in getBookData:', books);
    return books;
};